module.exports = __webpack_public_path__ + "static/media/restoreLife.62ff58b6.svg";